export const styles = {
  boxStyle: {
    position: "absolute",
    top: { xs: 0, sm: "50%" },
    left: { xs: 0, sm: "50%" },
    transform: { xs: "none", sm: "translate(-50%, -50%)" },
    width: { xs: "100%", sm: "85%", md: "65%", lg: "55%" },
    height: { xs: "100%", sm: "auto" },
    maxHeight: { xs: "100vh", sm: "92vh" },
    maxWidth: "960px",
    bgcolor: "#ffffff",
    borderRadius: { xs: 0, sm: "16px" },
    boxShadow: "0 24px 48px -12px rgba(15, 23, 42, 0.25)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    outline: "none",
  },
};
